import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/shared/config/queryKeys';
import { articleRepository } from './articleRepository';

/** All published articles, newest first. */
export function usePublishedArticles() {
  return useQuery({
    queryKey: queryKeys.articles.published,
    queryFn: () => articleRepository.listPublished(),
  });
}

/** A single published article by slug. */
export function useArticle(slug: string | undefined) {
  return useQuery({
    queryKey: queryKeys.articles.detail(slug ?? ''),
    queryFn: () => articleRepository.getPublishedBySlug(slug ?? ''),
    enabled: Boolean(slug),
  });
}
